import SafeImage from '@/components/SafeImage';

const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20cozy%20ambient%20warm%20lighting%2C%20comfortable%20seating%2C%20premium%20entertainment%20atmosphere%2C%20soft%20bokeh%20background%2C%20cinematic%20color%20grading%20with%20amber%20tones&width=800&height=500&seq=media-card-01&orientation=landscape',
    label: '观影指南',
    title: '打造家庭影院级观影体验',
    desc: '从设备选择到环境布置，牛牛影视带你解锁最佳观影姿势。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20film%20reels%20vintage%20movie%20tickets%20and%20popcorn%20on%20dark%20wooden%20surface%2C%20warm%20golden%20side%20lighting%2C%20nostalgic%20cinema%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20rich%20textures%2C%20editorial%20photography&width=800&height=500&seq=media-card-02&orientation=landscape',
    label: '片单推荐',
    title: '七月必看 · 十部冷门佳作',
    desc: '豆瓣8分以上却鲜为人知的宝藏影片，每一部都值得细品。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20silhouette%20of%20a%20person%20watching%20a%20bright%20movie%20screen%20in%20a%20dark%20room%2C%20colorful%20light%20reflections%20on%20the%20wall%2C%20immersive%20viewing%20experience%2C%20cinematic%20atmosphere%2C%20warm%20and%20cool%20contrasting%20light%2C%20artistic%20composition&width=800&height=500&seq=media-card-03&orientation=landscape',
    label: '追剧攻略',
    title: '零缓冲流畅追剧全攻略',
    desc: '牛牛极清模式下如何优化网络与设备设置，告别一切卡顿。',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          观影灵感从这里出发，发现更多精彩内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/70"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <SafeImage
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}